import { IPriceDayInterval, IProductPriceDailyDto, ISessionItem } from "@crunchit/types";

function getDays() {
  return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
}

/**
 * Calculates the day interval where prices are regular.
 *
 * E.g. with a given interval of `1` and `4` (sale from Monday - Thursday), this will return Friday - Sunday.
 *
 * @param productPriceDaily
 */
export const getRegularPriceDayInterval = (productPriceDaily: IProductPriceDailyDto): IPriceDayInterval => {
  const { startDayOfWeek, endDayOfWeek } = productPriceDaily;
  const daysLeft = getDays();

  for (let i = 0; i < startDayOfWeek; i++) {
    if (daysLeft.length) {
      daysLeft.push(daysLeft.shift() as string);
    }
  }

  const deleteCount = startDayOfWeek > endDayOfWeek ? startDayOfWeek + endDayOfWeek : Math.abs(startDayOfWeek - endDayOfWeek) + 1;

  daysLeft.splice(0, deleteCount);

  if (!daysLeft.length) {
    throw new Error(`Day interval ${startDayOfWeek} - ${endDayOfWeek} is invalid`);
  }

  const firstDay = daysLeft[0];

  if (daysLeft.length > 1) {
    return {
      firstDay,
      lastDay: daysLeft[daysLeft.length - 1],
    };
  }

  return { firstDay };
};

/**
 * Returns a function that will let the given product be sorted last, e.g. when sorting cart fees
 * @param productId
 */
export function sortProductLast(productId: number) {
  return (a: ISessionItem, b: ISessionItem) => {
    if (a.productId === productId) {
      // Sort a after b
      return 1;
    } else if (b.productId === productId) {
      // Sort b after a
      return -1;
    } else {
      // otherwise, sort the same as existing
      return 0;
    }
  };
}
